import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import { Accordion } from "@material-ui/core";
import { AccordionSummary } from "@material-ui/core";
import { AccordionDetails } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import HelpOutlineOutlinedIcon from "@material-ui/icons/HelpOutlineOutlined";
import PropTypes from "prop-types";
import { AppBar } from "@material-ui/core";
import { Tabs } from "@material-ui/core";
import { Tab } from "@material-ui/core";
import { Box } from "@material-ui/core";
import MenuBookOutlinedIcon from "@material-ui/icons/MenuBookOutlined";
import * as Scroll from "react-scroll";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  heading: {
    fontSize: theme.typography.pxToRem(10),
    fontWeight: theme.typography.fontWeightRegular,
    textAlign: "justify",
    // fontSize:theme.typography.fontSize=17,
  },
  des: {
    fontSize: theme.typography.pxToRem(10),
    lineHeight: "2",
    textAlign: "justify",
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export function FaqPage(props) {
  const classes = useStyles();
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  let scroll = Scroll.animateScroll;

  React.useEffect(() => {
    scroll.scrollToTop();
  }, []);

  return (
    <>
      <div className="row">
        <div className="w-100 p-0" id="jobHd">
          <div className="container w-100 h-100 d-flex align-items-center">
            <h1 className="text-white">
              <b>سوالات متداول</b>
            </h1>
          </div>
        </div>
        <div className="container h-auto " style={{ marginBlock: "3rem" }}>
          <div
            className="container pt-5 bg-white landings-container"
          >
            <h2
              className="p-4 col-6 col-md-3"
              style={{ borderBottom: "2.3px solid #6dd06d" }}
            >
              <b>سوالات متداول</b>
            </h2>
            <div className="d-block d-md-flex flex-wrap my-5">
              <div className="col-sm-12">
                <div className={`${classes.root} mt-3 pt-3 pb-3`}>
                  <Accordion className="mt-2 mb-2 p-1">
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <HelpOutlineOutlinedIcon
                        className="mr-4"
                        style={{ color: "green" }}
                        fontSize="medium"
                      />
                      <Typography className={classes.heading}>
                        چه زمانی می توانم اقدام به خرید بلیط کنم؟
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography className={classes.des}>
                        شما می توانید از 15 روز قبل از تاریخ حرکت تا 10 دقیقه
                        مانده به شروع حرکت اتوبوس بلیط خود را خریداری نمایید.
                        <br />
                        ما در ایباس خرید زودهنگام بلیط با قیمت های مناسب تر را
                        به شما پیشنهاد می کنیم.
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                  <Accordion className="mt-1 mb-2 p-1">
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <HelpOutlineOutlinedIcon
                        className="mr-4"
                        style={{ color: "green" }}
                        fontSize="medium"
                      />
                      <Typography className={classes.heading}>
                        آیا می توانم برای فرد دیگری بلیط اتوبوس خریداری کنم؟
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography className={classes.des}>
                        بله,می توانید برای یک شخص دیگر بلیط رزرو کنید. کافی است
                        هنگام رزرو نام دوست خود را وارد کرده و آدرس ایمیل یا
                        شماره تلفن ایشان را وارد کنید تا بلیط را مستقیماً دریافت
                        کنند. <br />
                        از طرف دیگر ,می توانید بلیط را به دوست خود ارسال کنید.
                        دوست شما می تواند شماره رزرو را در اپلیکیشن ایباس وارد
                        کرده و بلیط را مستقیماً از طریق تلفن خود دریافت کند.
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                  <Accordion className="mt-1 mb-2 p-1">
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <HelpOutlineOutlinedIcon
                        className="mr-4"
                        style={{ color: "green" }}
                        fontSize="medium"
                      />
                      <Typography className={classes.heading}>
                        امکان خرید بلیط به صورت افلاین وجود دارد؟
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography className={classes.des}>
                        در صورت وجود صندلی خالی ,می توانید از راننده اتوبوس
                        بلیط تهیه کنید. هنگام خرید بلیط از راننده اتوبوس ،
                        امتیازات شما قابل استفاده نیستند. رسید پرداخت هم بلیط
                        شما است و هم تأیید رزرو شما. لطفاً توجه داشته باشید که
                        بلیط های زود هنگام ,پیشنهادات ویژه و تخفیف های گروهی
                        فقط به صورت آنلاین در دسترس است.
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                  <Accordion className="mt-1 mb-2 p-1">
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <HelpOutlineOutlinedIcon
                        className="mr-4"
                        style={{ color: "green" }}
                        fontSize="medium"
                      />
                      <Typography className={classes.heading}>
                        شرایط خرید بلیط گروهی چگونه است؟
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography className={classes.des}>
                        اگر تعداد بلیط های شما از 8 عدد بیشتر نشود ,می توانید
                        بلیط سفرهای گروهی را از طریق برنامه و وب سایت ما رزرو
                        کنید. برای خرید بیش از 8 بلیط با کارشناسان ما تماس
                        بگیرید. علاوه بر این,می توانید با استفاده از سیستم
                        دربستی ایباس یک اتوبوس خصوصی همراه با راننده اجاره کنید.
                        تقریباً هرگونه درخواست خاصی امکان پذیر است. بلافاصله
                        قیمت به شما نشان داده می شود,که باعث رزرو سریع و آسان
                        اتوبوس شما خواهد بود. استرداد رایگان تا 7 روز قبل از
                        تاریخ سفر امکان پذیر است.{" "}
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                  <Accordion className="mt-1 mb-2 p-1">
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <HelpOutlineOutlinedIcon
                        className="mr-4"
                        style={{ color: "green" }}
                        fontSize="medium"
                      />
                      <Typography className={classes.heading}>
                        سفر به همراه کودکان چگونه است؟
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography className={classes.des}>
                        ایمنی مسافران کوچک ما برای ما اهمیت ویژه ای دارد.
                        بنابراین ,لطفاً به موارد زیر توجه کنید:
                        <br />
                        کودکان 2 تا 6 سال باید در صندلی کودک بنشینند که با
                        کمربند ایمنی مخصوص محافظت شوند. <br />
                        کودکان و نوجوانان زیر 18 سال باید به همراه یک فرد دارای
                        سن قانونی سفر کنند.
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                  <Accordion className="mt-1 mb-2 p-1">
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <HelpOutlineOutlinedIcon
                        className="mr-4"
                        style={{ color: "green" }}
                        fontSize="medium"
                      />
                      <Typography className={classes.heading}>
                        آیا نیاز به خرید بلیط اتوبوس برای کودکان زیر 2 سال هم
                        وجود دارد؟
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography className={classes.des}>
                        بلیط اتوبوس افراد زیر دو سال در صورتی که صندلی به آن‌ها
                        تعلق نگیرد رایگان است ولی در صورتی که نیاز به استفاده از
                        صندلی داشته باشید,می‌بایست هزینه بلیط اتوبوس را کامل
                        پرداخت نمایید.
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                  <Accordion className="mt-1 mb-2 p-1">
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <HelpOutlineOutlinedIcon
                        className="mr-4"
                        style={{ color: "green" }}
                        fontSize="medium"
                      />
                      <Typography className={classes.heading}>
                        آیا قیمت یا تخفیف ویژه ای برای کودکان در نظر گرفته شده
                        است؟
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography className={classes.des}>
                        مسافران جوان ما که هنوز تولد 15 سالگی خود را جشن نگرفته
                        اند ,با قیمت های کمتری با ما سفر می کنند. اگر در زمان
                        خرید شما قیمت بلیط آنلاین ما ارزان تر از بلیط کودک باشد
                        ,ما به طور خودکار این قیمت پایین تر را به شما ارائه می
                        دهیم زیرا همیشه در تلاشیم بهترین قیمت را پیشنهاد دهیم.
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                  <Accordion className="mt-2 mb-2 p-1">
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <HelpOutlineOutlinedIcon
                        className="mr-4"
                        style={{ color: "green" }}
                        fontSize="medium"
                      />
                      <Typography className={classes.heading}>
                        در صورت دیر رسیدن آیا اتوبوس منتظر من خواهد ماند؟
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography className={classes.des}>
                        متاسفانه اتوبوس نمی تواند منتظر مسافران که دیر میرسند
                        باشد. اتوبوس های ما در یک شبکه حرکت می کنند و به یک جدول
                        زمانی محدود می شوند. لطفاً اطمینان حاصل کنید که حداقل 15
                        دقیقه قبل از حرکت در ایستگاه هستید.
                        <br />
                        اگر متوجه شدید که قرار نیست در زمان مناسب خود را به
                        ایستگاه برسانید ,می توانید تا 30 دقیقه قبل از حرکت
                        اتوبوس از طریق سایت یا اپلیکیشن ایباس ,بلیط خود را لغو
                        کنید.
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                  <Accordion className="mt-2 mb-2 p-1">
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <HelpOutlineOutlinedIcon
                        className="mr-4"
                        style={{ color: "green" }}
                        fontSize="medium"
                      />
                      <Typography className={classes.heading}>
                        امکان حمل حیوانات خانگی در اتوبوس وجود دارد؟
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography className={classes.des}>
                        طبق قوانین سازمان حمل‌ونقل امکان حمل حیوانات زنده در
                        اتوبوس وجود ندارد.
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                  <Accordion className="mt-1 mb-2 p-1">
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <HelpOutlineOutlinedIcon
                        className="mr-4"
                        style={{ color: "green" }}
                        fontSize="medium"
                      />
                      <Typography className={classes.heading}>
                        جهت سوار شدن به اتوبوس چه مدت قبل از حرکت در ترمینال
                        حضور داشته باشیم؟
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography className={classes.des}>
                        15 دقیقه قبل از حرکت اتوبوس خود را به ایستگاه مورد نظر
                        برسانید.
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                  <Accordion className="mt-1 mb-2 p-1">
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <HelpOutlineOutlinedIcon
                        className="mr-4"
                        style={{ color: "green" }}
                        fontSize="medium"
                      />
                      <Typography className={classes.heading}>
                        چگونه می توانم بلیط اتوبوسم را استرداد کنم؟
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography className={classes.des}>
                        در صورت قابل استرداد بودن بلیط خریداری شده,در «پنل
                        کاربری» از منوی «سفارشات و استردادها»,سفارش مورد نظر را
                        انتخاب کنید؛ بعد از کلیک بر روی گزینه استرداد و تکمیل
                        مراحل,بلیط مورد نظر طبق قوانین و مقررات استرداد می‌شود.
                        هزینه‌ای که مسترد می‌شود به همان شماره حسابی واریز
                        می‌شود که خرید انجام شده است. اگر لازم است که هزینه
                        مسترد شده به حساب دیگری واریز گردد,باید با پشتیبانی
                        تماس گرفته و آن‌ها را در جریان بگذارید.
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                  <Accordion className="mt-1 mb-2 p-1">
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <HelpOutlineOutlinedIcon
                        className="mr-4"
                        style={{ color: "green" }}
                        fontSize="medium"
                      />
                      <Typography className={classes.heading}>
                        میزان بار مجاز برای هر مسافر چقدر است؟
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography className={classes.des}>
                        طبق قوانین سازمان حمل‌ونقل میزان بار مجاز 20 کیلوگرم
                        است.
                        <br />
                        اگر میزان بار اضافه شما بیش از حد باشد,می‌توانید در این
                        مورد صحبت کنید که هزینه میزان بار اضافه‌تان را پرداخت
                        کنید تا بتوانید همه وسیله‌هایتان را با خودتان حمل کنید.
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
